














































import Vue from 'vue';
import _ from 'lodash';
import { AxiosError } from 'axios';
// import { version } from '../package.json';

import { AvisoSnackbarOptions } from '../../back/src/types';

import AvisoSnackbar from './components/AvisoSnackbar.vue';
import MenuLateral from './components/MenuLateral.vue';
import requester from './requester';

export default Vue.extend({
  name: 'App',
  components: {
    AvisoSnackbar,
    MenuLateral,
  },
  data: () => ({
    // version,
    drawer: false,
    snackbar: {
      show: false,
      options: {} as AvisoSnackbarOptions,
    },
  }),
  computed: {
    usuario() {
      return this.$store.getters.usuario;
    },
    usuarioLogado(): boolean {
      return this.usuario && this.usuario.token;
    },
    toolbarTitle(): string {
      if (!this.$route.meta.title) {
        return 'OBSTETRIKA';
      }
      if (this.$vuetify.breakpoint.smAndUp) {
        return `OBSTETRIKA - ${this.$route.meta.title}`;
      }
      return this.$route.meta.title;
    },
  },
  created() {
    this.$root.$on('avisoSnackbar', (options: AvisoSnackbarOptions) => {
      this.avisoSnackbar(options);
    });
    this.$root.$on('requestError', (err: AxiosError) => {
      this.requestError(err);
    });
    window.onbeforeunload = () => this.onBeforeUnload();
  },
  methods: {
    onBeforeUnload() {
      if (this.$route.name === 'ConsultasAtender') {
        return 'Tem certeza que deseja fechar esta página? Os dados serão perdidos!';
      }
      return null;
    },
    avisoSnackbar(options: AvisoSnackbarOptions): void {
      this.snackbar.show = true;
      this.snackbar.options = {
        text: _.isArray(options.text) ? options.text : [options.text],
        color: options.color ? options.color : '',
        timeout: options.timeout ? options.timeout : 3000,
      };
    },
    requestError(err: AxiosError): void {
      if (!err.response) {
        this.avisoSnackbar({ color: 'error', text: err.toString() });
        return;
      }
      const errorMessage = `${err.response.status} - ${err.response.statusText}`;
      this.avisoSnackbar({ color: 'error', text: errorMessage });
      if (err.response.status >= 500) {
        this.$router.push({ name: 'Home' });
      } else if (err.response.status >= 400) {
        this.$router.push({ name: 'Login' });
      }
    },
    logout() {
      this.drawer = false;
      this.$store.dispatch('logout');
      this.$router.push({ name: 'Login' });
      this.avisoSnackbar({ color: 'success', text: 'Logout realizado com sucesso.' });
    },
  },
});
